<template>
  <div class="categoriesContainer">
    <div class="categories" v-if="categories.length > 0">
      <RadioInput
        type="button"
        class="category"
        v-for="category in categories"
        :key="category.id"
        :fname="category.id"
        :value="category.selected"
        v-on:input="setCategoryFilterLocal($event)"
        :label="category.name"
      ></RadioInput>
      <RadioInput
        type="link"
        class="category reset"
        v-if="!noCategoriesSelected"
        :value="!noCategoriesSelected"
        fname="all"
        v-on:input="resetCategoriesLocal()"
        :label="$t('RESET_CATEGORY')"
      ></RadioInput>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import RadioInput from '../Form/RadioInput.vue';

export default {
  name: 'CategorySelector',
  components: {
    RadioInput,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      language: (state) => state.language,
      categories: (state) => state.products.categories,
    }),
    ...mapGetters({
      noCategoriesSelected: 'products/noCategoriesSelected',
    }),
  },
  methods: {
    ...mapActions({
      getCategories: 'products/getCategories',
      setCategoryFilter: 'products/setCategoryFilter',
      resetAllCategories: 'products/resetAllCategories',
    }),
    setCategoryFilterLocal(p) {
      this.setCategoryFilter(p);
      this.setUrlQuery();
    },
    setUrlQuery() {
      const query = { category: [] };
      Object.keys(this.categories).forEach((c) => {
        const category = this.categories[c];
        if (category.selected) {
          query.category.push(category.name);
        }
      });
      this.$router.replace({ query }).catch(() => {});
    },
    resetCategoriesLocal() {
      const query = { category: [] };
      this.$router.replace({ query });
      this.resetAllCategories();
    },
    parseQuery() {
      let queryCategories = [];

      if (!Array.isArray(this.$route.query.category)) {
        queryCategories.push(this.$route.query.category);
      } else {
        queryCategories = this.$route.query.category;
      }
      if (typeof queryCategories !== 'undefined') {
        queryCategories.forEach((qc) => {
          const category = this.categories.find((c) => qc === c.name);
          if (typeof category !== 'undefined') {
            const { id } = category;
            if (typeof id !== 'undefined') {
              this.setCategoryFilter({ [id]: true });
            }
          }
        });
      }
    },
  },
  mounted() {
    let params = '';
    if (this.$route.name === 'passes') {
      params = 'annualPasses';
    }

    this.getCategories(params).then(() => {
      this.parseQuery();
    });
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/grid';

.categoriesContainer {
  //@extend .container-fluid;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.categories {
  @extend .col-md-12;
  margin-top: 3 * $sp;
  padding-right: $sp;
  margin-bottom: 4 * $sp;
  @media screen and (max-width: $screen-sm) {
    text-align: center;
  }
}
.category {
  margin-bottom: calc($sp/3);
  margin-left: calc($sp/6);
  margin-right: calc($sp/6);
  display: inline-block;
}
.reset {
  margin-left: $sp;
}
</style>
